import React from "react"

export default function ReadMessage() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="11" viewBox="0 0 17 11" fill="none">
         <path fillRule="evenodd" clipRule="evenodd" d="M16.3078 0.62879L16.9301 1.25108L10.196 10.7167L7.46625 7.95325L8.62225 6.32725L10.196 7.26808L16.3078 0.62879ZM10.843 0.489502L11.4653 1.1118L4.73123 10.5774L0.0935059 5.90171L1.12906 4.86616L4.73123 7.12879L10.843 0.489502Z" fill="#653fd5" />
      </svg>
   )
}
